import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Group, Line, Rect } from 'react-konva';
import { mapStrokeWidth } from '@/utils/board/strokeUtils';
export function circleGroup({ el, showElementSelectionBorder, layerLocked, common, clipFunc: _clipFunc, isVisible = true, isPresentationMode = false, }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const w = ((_a = el.props) === null || _a === void 0 ? void 0 : _a.w) || 80;
    const h = ((_b = el.props) === null || _b === void 0 ? void 0 : _b.h) || 80;
    const fill = ((_c = el.props) === null || _c === void 0 ? void 0 : _c.fill) || '#ffffff';
    const opacityValue = (_d = el.props) === null || _d === void 0 ? void 0 : _d.opacity;
    const opacity = typeof opacityValue === 'number' && !isNaN(opacityValue) ? opacityValue : 1;
    const strokeValue = (_e = el.props) === null || _e === void 0 ? void 0 : _e.stroke;
    const strokeWidthValue = (_f = el.props) === null || _f === void 0 ? void 0 : _f.strokeWidth;
    const stroke = typeof strokeValue === 'string' && strokeValue ? strokeValue : undefined;
    const logicalStrokeWidth = typeof strokeWidthValue === 'number' && !isNaN(strokeWidthValue) ? strokeWidthValue : 5;
    // Применяем маппинг для физического размера обводки
    const strokeWidth = mapStrokeWidth(logicalStrokeWidth);
    let strokeEnabled = false;
    if (isPresentationMode && el.isPresentationFrame) {
        strokeEnabled = false;
    }
    else {
        strokeEnabled =
            typeof ((_g = el.props) === null || _g === void 0 ? void 0 : _g.strokeEnabled) === 'boolean'
                ? el.props.strokeEnabled
                : stroke !== undefined && stroke !== null;
    }
    return (_jsxs(Group, Object.assign({}, common, { visible: isVisible, children: [_jsx(Rect, { width: w, height: h, fill: "transparent", listening: false, shadowForStrokeEnabled: false }), _jsx(Line, { sceneFunc: (ctx, shape) => {
                    ctx.beginPath();
                    ctx.ellipse(w / 2, h / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
                    ctx.closePath();
                    ctx.fillStrokeShape(shape);
                }, fill: fill, stroke: strokeEnabled ? stroke : undefined, strokeWidth: strokeWidth, strokeScaleEnabled: true, shadowForStrokeEnabled: false, perfectDrawEnabled: false, opacity: opacity }), showElementSelectionBorder && (_jsx(Rect, { width: w, height: h, stroke: el.locked || layerLocked ? '#d33' : '#5eafffff', strokeWidth: 2, strokeScaleEnabled: false, listening: false, shadowForStrokeEnabled: false, perfectDrawEnabled: false }))] }), el.id));
}
